import React from 'react';
import Navbar from './components/Navbar';
import Container from './components/Container'
import './App.css';
import axios from 'axios';
import Footer from './components/Footer';

function App() {
  const [items, setItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(()=> {
    const fetchItems = async() => {
      const result = await axios(`https://friends-quotes-api.herokuapp.com/quotes`)
      // console.log(result.data)
      setItems(result.data)
      setIsLoading(false)
    }
    fetchItems()
  }, [])
  return (
    <div className="body">
      <Navbar />
      <Container items={items} isLoading={isLoading}/>
      <Footer/>
    </div>
  );
}

export default App;
